import { FC } from 'react';

interface UnsavedChangesModalProps {
  open: boolean;
  isSaving: boolean;
  /** Ausente quando a página não registrou como salvar — some o botão. */
  onSaveAndLeave?: () => void;
  onLeave: () => void;
  onCancel: () => void;
}

/**
 * Três saídas, porque duas seriam uma armadilha: sair perdendo, salvar e sair,
 * ou ficar. O app original perdeu dados uma vez (DT-B06) — aqui nada some calado.
 */
const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  open,
  isSaving,
  onSaveAndLeave,
  onLeave,
  onCancel,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="seop-unsaved-title"
        data-testid="seop-unsaved-modal"
        className="w-full max-w-md rounded-xl border border-theme-border bg-surface-card p-6"
      >
        <h2 id="seop-unsaved-title" className="text-lg font-semibold text-content-primary">
          Você tem alterações não salvas
        </h2>
        <p className="mt-2 text-sm text-content-secondary">
          Sair agora descarta o que foi editado nesta tela.
        </p>
        <div className="mt-5 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-theme-border px-4 py-2 text-sm text-content-secondary hover:text-content-primary"
          >
            Cancelar
          </button>
          <button
            type="button"
            data-testid="seop-unsaved-leave"
            onClick={onLeave}
            className="rounded-lg border border-theme-danger/40 px-4 py-2 text-sm text-theme-danger hover:bg-theme-danger/10"
          >
            Sair sem salvar
          </button>
          {onSaveAndLeave && (
            <button
              type="button"
              data-testid="seop-unsaved-save"
              disabled={isSaving}
              onClick={onSaveAndLeave}
              className="rounded-lg bg-accent px-4 py-2 text-sm font-semibold text-accent-contrast hover:bg-accent-hover disabled:opacity-50"
            >
              {isSaving ? 'Salvando…' : 'Salvar e sair'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
